import { useFormAtom } from "@impero-com/common/utils/form/formAtom/hooks";
import { FormAtom } from "@impero-com/common/utils/form/formAtom/types";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { Atom, useAtomValue } from "jotai";

import { FieldCmp } from "components/fieldBuilder/fieldCmp";

import { getConclusionFieldTypeInfo } from "./fieldBuilderUtils";
import { ControlConclusionField, SampleConclusionField } from "./schema";

interface ConclusionFieldCmpProps<
    T extends SampleConclusionField | ControlConclusionField,
> {
    fieldAtom: FormAtom<T>;
    disabled?: boolean;
    openDrawer: () => void;
    fieldsAtom: Atom<T[]>;
}
export function ConclusionFieldCmp<
    T extends SampleConclusionField | ControlConclusionField,
>({ fieldAtom, openDrawer, fieldsAtom, disabled }: ConclusionFieldCmpProps<T>) {
    const { t } = useTranslation();
    const fields = useAtomValue(fieldsAtom);
    const { value: field, error } = useFormAtom(fieldAtom);
    return (
        <FieldCmp
            fields={fields}
            field={field}
            error={error}
            disabled={disabled}
            openDrawer={openDrawer}
            svgSrc={getConclusionFieldTypeInfo(t)(field.fieldType.type).svg}
        />
    );
}
